/**
 * @generated SignedSource<<8507a83e76da2418e4990918ff7a8deb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventVisibility = "LISTED" | "UNLISTED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventScreenNewCoverPhoto_event$data = {
  readonly coverPhoto: {
    readonly transformUrl: string;
  } | null | undefined;
  readonly name: string;
  readonly prettyUrl: string;
  readonly rowId: string;
  readonly updatedAt: string | null | undefined;
  readonly visibility: EventVisibility;
  readonly " $fragmentType": "EventScreenNewCoverPhoto_event";
};
export type EventScreenNewCoverPhoto_event$key = {
  readonly " $data"?: EventScreenNewCoverPhoto_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenNewCoverPhoto_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenNewCoverPhoto_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "coverPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "transform",
              "value": {
                "dpr": 3,
                "w": 368
              }
            }
          ],
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":368})"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "3417bc1e986a1a5fb9e31bf820bf6e74";

export default node;
